// removed by extract-text-webpack-plugin
module.exports = {"content":"app-2MYRcNAM"};


//////////////////
// WEBPACK FOOTER
// ./src/wbap-components/pageHeaderLayout/index.less
// module id = 685
// module chunks = 0